import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import Slider, {Range}  from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import ScalePoints from "container/Question/ScalePoints";
import QuestionContainer from "../../Components/questionContainer";
import _ from "lodash";
import {SliderInputs} from "../../Components/slider/sliderInputs";
import SliderSummary from "../../Components/slider/sliderSummary";

class PresentationTypeSlider extends Component {

  constructor(props){
    super(props);
    this.sliderInputs = React.createRef();
    this.state = {
      touched: false
    };

    this.onValueChange = this.onValueChange.bind(this);
    this.getSlider = this.getSlider.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.getMinValue = this.getMinValue.bind(this);
    this.getMaxValue = this.getMaxValue.bind(this);
    this.getFormattedValue = this.getFormattedValue.bind(this);
  }

  onValueChange(value, property){
    let {detail, question} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    detail = {
      ...detail,
      microTime,
      [property]: value,
    };

    this.setState({
      touched: true
    })

    this.props.onDetailUpdated(detail);
    if (question.showSliderInputs && this.sliderInputs && this.sliderInputs.current && this.sliderInputs.current.setInputValueForce) {
      this.sliderInputs.current.setInputValueForce(detail);
    }
  }

  getFormattedValue(value){
    const {question} = this.props;

    return value;
  }

  getDefaultValue(){
    if(this.props.question.defaultValueMiddle){
      return ((this.getMaxValue() - this.getMinValue()) / 2) + this.getMinValue();
    }

    return this.props.question.defaultValue;
  }

  getMinValue(){
    const {question} = this.props;

    return Number(question.valueMin)
  }

  getMaxValue(){
    const {question} = this.props;

    return Number(question.valueMax)
  }

  getSlider() {
    const {detail, question, validate} = this.props;
    const Handle = Slider.Handle;
    let min = this.getMinValue();
    let max = this.getMaxValue();
    if (min && question.decimals) {
      min = min * Math.pow(10, question.decimals)
    }
    if (max && question.decimals) {
      max = max * Math.pow(10, question.decimals)
    }
    let defaultValue = this.getDefaultValue()
    if (defaultValue && question.decimals) {
      defaultValue = defaultValue * Math.pow(10, question.decimals)
    }
    let value1 = detail.value1;
    let value2 = detail.value2;

    const handle = (props) => {
      const { value, dragging, index, ...restProps } = props;

      let valueDisplay = this.getFormattedValue(value);
      if (question.decimals) {
        valueDisplay = valueDisplay / Math.pow(10, question.decimals)
      }

      if(question.valueText){
        valueDisplay += ' ' + question.valueText;
      }

      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={valueDisplay}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={valueDisplay} {...restProps} />
        </Tooltip>
      );
    };

    if (this.props.question.range) {
      return <Range
        className={(!_.isNull(validate) && validate.errors.length > 0) ? "error" : ""}
        handle={question.hideSelectingValue ? undefined : handle}
        min={min}
        max={max}
        step={question.step}
        onChange={(values) => {
          if (values[0] !== value1) {
            values[0] = this.getFormattedValue(values[0])
            this.onValueChange(values[0], 'value1');
          } else {
            values[1] = this.getFormattedValue(values[1])
            this.onValueChange(values[1], 'value2');
          }
        }}
        value={(!_.isNull(detail.value1) || !_.isNull(detail.value2)) ? [value1, value2] : [min, max]}
        count={2}
      />;
    }


    return <React.Fragment>
      <Slider
          className={(!_.isNull(validate) && validate.errors.length > 0) ? "error" : ""}
          handle={question.hideSelectingValue ? undefined : handle}
          min={min}
          max={max}
          step={question.step}
          onChange={(value) => {
            value = this.getFormattedValue(value)

            this.onValueChange(value, 'value1')
          }}
          value={!_.isNull(detail.value1) ? value1 : defaultValue}
      />
    </React.Fragment>;
  }

  render() {
    const {question, detail, validate} = this.props;
    const {touched} = this.state;

    return <QuestionContainer
        classes={"pt-0 mt-4"}
      component={
        <div>
          <SliderInputs
            ref={this.sliderInputs}
            touched={touched}
            question={question}
            detail={detail}
            isError={(!_.isNull(validate) && validate.errors.length > 0)}
              onValueChangeFirst={(value) => {
                this.onValueChange(value, 'value1')
              }}
              onValueChangeSecond={(value) => {
                this.onValueChange(value, 'value2')
              }}
          />
          {!question.scalePoints && <div className="d-flex">
            <span className="w-50">{question.valueMin} {question.valueText}</span>
            <span className="w-50 text-right">{question.valueMax} {question.valueText}</span>
          </div>}
          <div className={"mr-3 ml-3 mt-3"}>
            <div className={"mb-3"}>
              <ScalePoints scalePoints={question.scalePoints} />
            </div>
            {this.getSlider()}
            <SliderSummary question={question} detail={detail} max={this.getMaxValue()} min={this.getMinValue()} />
          </div>
        </div>
      }
    />
  }
}

PresentationTypeSlider.propTypes = {
  validate: PropTypes.any,
  detail: PropTypes.shape({
    value1: PropTypes.number,
    value2: PropTypes.number,
  }),
  question: PropTypes.shape({
    valueMin: PropTypes.number.isRequired,
    valueMax: PropTypes.number.isRequired,
    decimals: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    valueText: PropTypes.string,
    hideSelectedValue: PropTypes.bool.isRequired,
    hideSelectingValue: PropTypes.bool.isRequired,
    scalePoints: PropTypes.array.isRequired,
    range: PropTypes.bool.isRequired
  }).isRequired,
  onDetailUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true})(PresentationTypeSlider);